import { ILoginToken } from 'app/shared/models/authtoken';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { catchError, Observable, take, tap, map } from 'rxjs';


@Injectable()
export class AuthenticationService {
    private tokenName = 'crm-token';

    saveToken(token: ILoginToken): void {
        const currentDate = new Date(Date.now());
        currentDate.setSeconds(currentDate.getSeconds() + token.expires_in);
        token.expiry_date = currentDate;
        localStorage.setItem(this.tokenName, JSON.stringify(token));
    }

    constructor(
        private msalService: MsalService
    ) {
    }
    

    isAuthenticated(): boolean {
        const storageItem = localStorage.getItem(this.tokenName);
        let result = false;
        if (storageItem) {
            const jsonToken: ILoginToken = <ILoginToken>JSON.parse(storageItem, (key: string, value) => {
                if (key === 'expiry_date') {
                    return new Date(value);
                } else {
                    return value;
                }
            });
            if (new Date(Date.now()) < jsonToken.expiry_date) {
                result = true;
            }
        }
        return result;
    }

    logOut(): void {
        localStorage.removeItem(this.tokenName);
    }

    getHeaders(): HttpHeaders {
        const storageItem = localStorage.getItem(this.tokenName);
        const token = <ILoginToken>JSON.parse(storageItem);
        const headers = new HttpHeaders({ 'Authorization': 'bearer ' + token ? token!.access_token : '' });
        return headers;
    }

    getToken(): string {
        const storageItem = localStorage.getItem(this.tokenName);
        const token = <ILoginToken>JSON.parse(storageItem);
        return token.access_token;
    }

}
